import { render, staticRenderFns } from "./CartAnimationPlaceholder.vue?vue&type=template&id=2e78f3fe&"
import script from "./CartAnimationPlaceholder.vue?vue&type=script&lang=js&"
export * from "./CartAnimationPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./CartAnimationPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports